<template>
  <sky-suffix v-bind="$attrs" @search-click="search">
    <el-input  v-bind="$attrs" v-model="zone" @change="outChange" class="sub"></el-input>
    <el-col class="line" :span="1">-</el-col>
    <el-input  v-bind="$attrs" v-model="phone" @change="outChange"></el-input>
    <slot name="toolTips" slot="toolTips"></slot>
  </sky-suffix>
</template>
<script>
  import SkySuffix from '../formComponents/SkySuffix.vue'
  export default {
    name: 'sky-tel',
    componentName: 'sky-tel',
    components: {
      SkySuffix
    },
    props: ['value'],
    data () {
      return {
        zone: '',
        phone: '',
        telephone: []
      }
    },
    watch: {
      value(){
        if(this.value.length > 0){
        }else{
          this.zone = "";
          this.phone = ""
        }
      },
      zone(){
       if(this.zone){
         this.telephone[0] = this.zone
       }else{
          this.telephone[0] = ""
       }
      },
      phone(){
       if(this.zone){
         this.telephone[1] = this.phone
       }else{
          this.telephone[1] = ""
       }
      }

    },
    methods: {
      search (e) {
        this.$emit('search-click', e)
      },
      outChange(e) {
        this.$emit('input', this.telephone)
      }
    }
  }
</script>
<style scoped lang="scss">
  .sub {
    width:30%
  }
 .line{
   text-align: center;
 }
</style>
